import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import icons from './icon-list'
import style from './index.scss'

interface IconProps {
  size: 'small' | 'medium' | 'large'
  type: string
  className?: string
}

const Icon = ({ size, type, className, ...iconProps }: IconProps) => {
  let IconSVG
  try {
    IconSVG = require(`./assets/${size}/${type}.inline.svg`)
  } catch (err) {
    //
  }
  return IconSVG ? (
    <IconSVG className={classNames(style.Icon, className)} {...iconProps} />
  ) : null
}

const validateType = (props: IconProps) => {
  const { size, type } = props
  if (!type) {
    return new Error('Prop type is required for Icon')
  }
  if (!size || !icons[size].includes(type)) {
    return new Error(`Invalid type, or size combination for icon: ${type}`)
  }
  return null
}

Icon.defaultProps = {
  size: 'medium',
}

Icon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  type: validateType,
  className: PropTypes.string,
}

export default Icon
